'use strict';

(function (angular) {
    'use strict';

    angular.module('zp.api').service('zpData', zpData);

    /** @ngInject */
    function zpData($http) {

        var service = this;

        service.http = http;

        //////////////////////////////////

        function http(params) {

            params.url = '/data' + params.url;

            return $http(params).then(function (response) {
                return response.data;
            });
        }
    }
})(window.angular);